import { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getPostcodePlanObjectives } from '../../../../actions/postcode-plan';
import ArrowButton from '../../../../components/common/button-arrow';
import PageTitle from '../../../../components/common/page-title';
import PostcodePlansList from './postcode-plans-list';

import './styles.css';
import PostcodePlanSearch from './postcode-plan-search';

class PostcodePlans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      dateFrom: '',
      dateTo: ''
    };
  }

  handleNameChange = (e) => {
    this.setState({ name: e.target.value });
  };

  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateFrom: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateFrom: '' });
    }
  };

  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateTo: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateTo: '' });
    }
  };

  handleClear = () => {
    this.setState({
      name: '',
      dateFrom: '',
      dateTo: ''
    }, this.handleSearch);
  };

  handleSearch = () => {
    const { dispatch } = this.props;
    const {
      name, dateFrom, dateTo
    } = this.state;

    dispatch(getPostcodePlanObjectives(
      name,
      dateFrom,
      dateTo
    ));
  };
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getPostcodePlanObjectives());
  }

  render() {
    const { postcodePlanObjectives } = this.props;
    const {
      name, dateFrom, dateTo
    } = this.state;

    return (
      <div className='container-fluid postcode-plan'>
        <PageTitle>Postcode Plans</PageTitle>
        <PostcodePlanSearch
          dateFromValue={dateFrom}
          dateToValue={dateTo}
          nameValue={name}
          onDateFromChange={this.handleDateFromChange}
          onDateToChange={this.handleDateToChange}
          onNameChange={this.handleNameChange}
          onSearch={this.handleSearch}
          onClear={this.handleClear}
        />
        <Row>
          <Col md={12}>
            <Link to='/admin/objectives/postcode-plans/new'>
              <ArrowButton
                color='red'
                arrow={false}
                submit={false}
                className='add-postcode-plan'
              >
                ADD POSTCODE PLAN SUB OBJECTIVE
              </ArrowButton>
            </Link>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <PostcodePlansList postcodePlans={postcodePlanObjectives} />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  postcodePlanObjectives: state.postcode_plans.postcode_plan_objectives,
});

export default connect(mapStateToProps)(PostcodePlans);
